import React from 'react';

import Chip from '@mui/material/Chip';

import { messageUtility } from '../../utilities/messageUtility';
import { PUBLICATION_STATUS } from '../../utilities/constants';

/**
 * 現場掲示板 公開情報Chips
 * @param { Number }bulletinBoardPublicationStatusId: 公開ステータスID
 * @returns { JSX.Element }
 */
export function FieldBulletinBoardPublicationStatusChip({
  bulletinBoardPublicationStatusId,
}) {
  return (
    <React.Fragment>
      {bulletinBoardPublicationStatusId == PUBLICATION_STATUS.DRAFT.id && (
        <Chip
          label={messageUtility.getMessage('I-000-164-13')}
          size='small'
          sx={{
            backgroundColor: PUBLICATION_STATUS.DRAFT.chipColor,
            borderRadius: '1rem',
            fontWeight: 'normal',
            lineHeight: '1.5rem',
          }}
        />
      )}
      {bulletinBoardPublicationStatusId == PUBLICATION_STATUS.PUBLISH.id && (
        <Chip
          label={messageUtility.getMessage('I-000-164-14')}
          size='small'
          sx={{
            backgroundColor: PUBLICATION_STATUS.PUBLISH.chipColor,
            borderRadius: '1rem',
            fontWeight: 'normal',
            lineHeight: '1.5rem',
          }}
        />
      )}
      {bulletinBoardPublicationStatusId == PUBLICATION_STATUS.STOP.id && (
        <Chip
          label={messageUtility.getMessage('I-000-164-15')}
          size='small'
          sx={{
            backgroundColor: PUBLICATION_STATUS.STOP.chipColor,
            borderRadius: '1rem',
            fontWeight: 'normal',
            lineHeight: '1.5rem',
          }}
        />
      )}
      {bulletinBoardPublicationStatusId == PUBLICATION_STATUS.RESERVE.id && (
        <Chip
          label={messageUtility.getMessage('I-000-164-16')}
          size='small'
          sx={{
            backgroundColor: PUBLICATION_STATUS.RESERVE.chipColor,
            borderRadius: '1rem',
            fontWeight: 'normal',
            lineHeight: '1.5rem',
          }}
        />
      )}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardPublicationStatusChip.jsx